import { Fragment, memo, SyntheticEvent } from 'react';
import cls from 'classnames';
import { ErrorResponse } from '@remix-run/router';

import { HTTPResponse, useMount, useToggle } from '@cutwise/utils';

import styles from './ErrorPage.module.scss';

interface ErrorPageProps {
  error: Error;
  title?: string;
}

function ErrorPage(props: ErrorPageProps) {
  const { error, title = 'Something went wrong' } = props;

  const isForbidden = (error as unknown as ErrorResponse).status === HTTPResponse.Forbidden;

  if (!isForbidden) {
    console.error(error.name, error.message);
  }

  const [isReported, report] = useToggle();

  function onReport(e: SyntheticEvent) {
    e.preventDefault();
    e.stopPropagation();

    report();
  }

  useMount(() => {
    if (!isForbidden) {
      window.ga?.('event', error.message);
    }
  });

  return (
    <div className={cls('container', styles.errorPage)}>
      <div className={styles.content}>
        {isForbidden && <h2 className={styles.errorTitle}>{(error as unknown as ErrorResponse).data}</h2>}

        {!isForbidden && (
          <Fragment>
            {!isReported && (
              <Fragment>
                <h2 className={styles.errorTitle}>{title}</h2>

                {error.message && <div className={styles.errorSubtitle} dangerouslySetInnerHTML={{ __html: error.message }} />}

                <a href="#" className={styles.errorReport} onClick={onReport}>
                  Report this issue to Cutwise
                </a>
              </Fragment>
            )}

            {isReported && (
              <Fragment>
                <h2 className={styles.successTitle}>Thank you for reporting!</h2>

                <p className={styles.errorSubtitle}>Your report helps make DiLog a better, trustworthy, and more welcoming to everyone.</p>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default memo(ErrorPage);
